module.exports = __webpack_public_path__ + "tm.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/tm.svg
// module id = 846
// module chunks = 0